export default __webpack_public_path__ + "static/media/702.ae980e4a.png";